import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-flash-screen',
  templateUrl: './flash-screen.component.html',
  styleUrl: './flash-screen.component.scss'
})
export class FlashScreenComponent {
  userId: any;
  constructor(private router: Router, private localStorageService: LocalStorageService) {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    if (this.userId != 0 && this.userId != null && this.userId != undefined && this.userId != '') {
      setTimeout(() => {
        this.router.navigate(['/dashboard']);
      }, 2000);
    } else {
      setTimeout(() => {
        this.router.navigate(['/auth/login']);
      }, 2000);
    }
  }
}
